import React from 'react';
import { trackEvent } from '../utils/pixel';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  const cartUrl = 'https://www.benorialiving.com/cart/50796366201118:1';
  const handleAddToCart = () => {
    trackEvent('AddToCart', {
      content_name: 'The 3:15 AM Panic Switch',
      content_type: 'product',
      value: 6.36,
      currency: 'USD'
    });
  };
  return <section id="final-cta" className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-30">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-31"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-32">
        <FadeIn data-id="element-33">
          <h3 className="font-serif text-4xl md:text-5xl text-white mb-6" data-id="element-34">
            Ready to sleep through the night?
          </h3>

          <p className="text-xl text-cream/90 mb-12 max-w-2xl mx-auto" data-id="element-35">
            Reclaim your sleep for less than the cost of a ruined morning's
            worth of extra-strength espresso.
          </p>

          <div className="bg-night-800/80 backdrop-blur-md border border-amber-500/30 rounded-2xl p-8 md:p-12 shadow-glow-lg" data-id="element-36">
            <div className="mb-8" data-id="element-37">
              <div className="text-cream/50 line-through text-2xl mb-2" data-id="element-38">
                $19.99
              </div>
              <div className="text-amber-500 font-bold text-6xl tracking-tight" data-id="element-39">
                $6.36
              </div>
            </div>

            <Button href={cartUrl} className="w-full md:w-auto text-lg py-5 px-10 mb-6" onClick={handleAddToCart} data-id="element-40">
              GET THE PROTOCOL NOW
            </Button>

            <div className="flex items-center justify-center gap-2 text-cream/60 text-sm" data-id="element-41">
              <ShieldCheck className="w-4 h-4" data-id="element-42" />
              <span data-id="element-43">Digital Delivery: Start Sleeping Better Tonight</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}